"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterTestIdPrefix = exports.updateFilter = void 0;
const utils_1 = require("../../utils");
function updateFilter(currentFilter, key, value) {
    if (value === undefined) {
        return (0, utils_1.omitKey)(key, currentFilter);
    }
    else {
        return { ...currentFilter, [key]: value };
    }
}
exports.updateFilter = updateFilter;
exports.filterTestIdPrefix = "filter";
